import { render, staticRenderFns } from "./organization-control-test-history.vue?vue&type=template&id=9e3fda7c&"
import script from "./organization-control-test-history.vue?vue&type=script&lang=js&"
export * from "./organization-control-test-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports